var map = {
	"./site-logo-desktop-footer.svg": 83250,
	"./site-logo-drawer-mobile.svg": 71000,
	"./site-logo-drawer.svg": 99997,
	"./site-logo-wrapper-mobile-scrolled.svg": 65547,
	"./site-logo-wrapper-mobile.svg": 40146,
	"./site-logo-wrapper-scrolled.svg": 62204,
	"./site-logo-wrapper.svg": 61299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26401;